import { useEffect } from 'react'
import { useLocation, useNavigate, Outlet, useParams } from 'react-router-dom'
import { detectCityFromURL } from '../../utils/cityDetector'
import { saveLastCityUrl } from '../../utils/lastCityStorage'
import { useDispatch, useStore } from 'react-redux'
import { Box, Stack } from '@mui/material'

import { REPORT_ROUTE } from '../../config/routes'
import * as RT from '../../config/routeType'
import AppBarMenu from '../../components/AppBarMenu'
import MapWrapper from '../../components/MapboxGL/MapWrapper'
import BoxConfirmation from '../../components/BoxConfirmation'
import DrawerLeftMenu from '../../components/DrawerLeftMenu'
import { setOpen } from '../../redux/slices/Modal/modalBoxConfirmation'
import Map from '../../components/MapboxGL'
import WelcomeOverlay from '../../components/WelcomeOverlay'

const AppPage = ({
  isAuthenticated: isAuth,
  user,
  isAdmin,
  hideMap = false,
  hideBar = false,
}) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const pathname = location.pathname
  // City derived from URL so AppPage doesn't need remounting when canton changes
  const city = detectCityFromURL(pathname)
  const { iso2, canton, treeId } = useParams()
  const store = useStore()

  // Persistir la URL base del cantón activo para poder regresar a ella
  // desde rutas sin ciudad (ej. página 404).
  useEffect(() => {
    if (city && iso2 && canton) {
      saveLastCityUrl(`/${iso2.toLowerCase()}/${canton}`)
    }
  }, [city, iso2, canton])

  const propsmap = { isAdmin, isAuth, pathname, store }

  // El wizard ocupa /registrar-arbol y /editar-arbol/:treeId y gestiona su propio mapa internamente
  const isRegisterWizardRoute = pathname.includes(RT.REGISTER_TREE)
  const isEditWizardRoute = pathname.includes(RT.MANAGEMENT_TREE) && Boolean(treeId)
  // Rutas de wizard: ocultan el mapa de AppPage y usan ancho completo
  const isWizardRoute = isRegisterWizardRoute || isEditWizardRoute

  const mapDimensions = hideMap
    ? { width: '0px', height: '0px' }
    : { width: '100%', height: '100vh' }

  return (
    <Box sx={{ display: 'flex', width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <MapWrapper>
        {!hideBar && <AppBarMenu city={city} isAuth={isAuth} user={user} />}

        <Stack
          direction="row"
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            position: 'relative',
          }}>
          {/* 🗺️ CONTENEDOR DEL MAPA */}
          {!hideMap && !isWizardRoute && (
            <Box
              sx={{
                width: mapDimensions.width,
                height: mapDimensions.height,
                flexShrink: 0,
                position: 'relative',
                zIndex: 10,
              }}>
              <Map {...propsmap} mapDimensions={mapDimensions} />
            </Box>
          )}

          <Outlet />
        </Stack>
      </MapWrapper>

      {!hideMap && <WelcomeOverlay />}
      <DrawerLeftMenu />

      <BoxConfirmation
        title="Este proceso puede tardar un poco. ¿Desea continuar?"
        description="La carga de los registros forestales puede tardar unos segundos debido al volumen de datos almacenados."
        width={`min(calc(100vw - 20%), 400px)`}
        handleCancel={() => dispatch(setOpen(false))}
        handleContinue={() => {
          dispatch(setOpen(false))
          navigate(REPORT_ROUTE, { replace: false })
        }}
      />
    </Box>
  )
}

export default AppPage
